import { types } from "../types";
const initialState = {
  courses: [],
  campus: "",
  courseToUpdate: null,
  courseToDelete: null,
  courseName: null,
};

export const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getCourse:
      return {
        ...state,
        courses: action.payload,
      };

    case types.createCourse:
      return {
        ...state,
        courses: [action.payload, ...state.courses],
      };
    case types.updateCourse:
      return {
        ...state,
        courses: state.courses.map((course) =>
          course._id === action.payload._id ? action.payload : course
        ),
      };

    case types.deleteCourse:
      return {
        ...state,
        courses: state.courses.filter(
          (course) => course._id !== action.payload
        ),
      };

    case types.setCampusFromCollege:
      return {
        ...state,
        campus: action.payload || "",
      };

    case types.setCourseToUpdate:
      return {
        ...state,
        courseToUpdate: action.payload,
      };

    case types.removeCourseFromUpdate:
      return {
        ...state,
        courseToUpdate: null,
      };

    case types.setCourseToDelete:
      return {
        ...state,
        courseToDelete: action.payload,
        courseName: state.courses.filter((course) =>
          course._id === action.payload ? course : null
        ),
      };

    case types.removeCourseFromDelete:
      return {
        ...state,
        courseToDelete: null,
      };

    default:
      return state;
  }
};
